import { render, staticRenderFns } from "./AlertsEdit.vue?vue&type=template&id=2445d21f&"
import script from "./AlertsEdit.vue?vue&type=script&lang=js&"
export * from "./AlertsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports